import { useList } from "@refinedev/core";
import type { IShipco } from "interfaces";

export const DEACTIVATED_VESSELS_SHIPCO_NAME = "Deactivated Vessels";

/** Where the lookup of the Deactivated Vessels shipco stands. */
export type DeactivatedVesselsLookupStatus =
  | "pending"
  | "failed"
  | "missing"
  | "found";

export interface DeactivatedVesselsLookup {
  /** The shipco's id; null until the lookup answers, when it failed or when the shipco is missing. */
  shipcoId: number | null;
  /** `missing`: the lookup answered with no such shipco. `failed`: it could not be answered. */
  status: DeactivatedVesselsLookupStatus;
}

/**
 * The "Deactivated Vessels" shipco, looked up by name as the New transfer
 * form does (create.tsx), with where the lookup stands.
 */
export const useDeactivatedVesselsLookup = (): DeactivatedVesselsLookup => {
  const { result, query } = useList<IShipco>({
    resource: "shipco",
    filters: [
      {
        field: "registrationName",
        operator: "eq",
        value: DEACTIVATED_VESSELS_SHIPCO_NAME,
      },
    ],
    pagination: { pageSize: 1 },
  });
  const shipcoId = result?.data?.[0]?.id;
  if (shipcoId) {
    return { shipcoId: Number(shipcoId), status: "found" };
  }
  if (query.isPending) {
    return { shipcoId: null, status: "pending" };
  }
  return { shipcoId: null, status: query.isError ? "failed" : "missing" };
};

/**
 * The id of the "Deactivated Vessels" shipco; null until the lookup answers
 * or when the shipco is missing.
 */
export const useDeactivatedVesselsShipcoId = (): number | null =>
  useDeactivatedVesselsLookup().shipcoId;
